import React from 'react'
import { Button, Card, DatePicker, Form, Input, Modal, Space, Table, Tag, message } from 'antd'
import dayjs from 'dayjs'
import { apiUrl } from '../../config/api'
import '../../config/httpInterceptor'

export default function AdminUserOtps() {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [editing, setEditing] = React.useState(null)
  const [form] = Form.useForm()

  async function load() {
    setLoading(true)
    try {
      const resp = await fetch(apiUrl('/api/admin/user-otps'))
      if (!resp.ok) throw new Error('failed')
      const json = await resp.json()
      setData(Array.isArray(json) ? json : [])
    } catch (e) {
      console.error(e)
      message.error('فشل في تحميل أكواد OTP')
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => { load() }, [])

  function openEdit(record) {
    setEditing(record)
    form.setFieldsValue({
      phoneNumber: record.phoneNumber,
      code: record.code,
      expiry: record.expiry ? dayjs(record.expiry) : null,
      attempts: record.attempts,
      status: record.status,
    })
  }

  async function saveEdit() {
    try {
      const values = await form.validateFields()
      const payload = {
        ...values,
        expiry: values.expiry ? values.expiry.toISOString() : null,
      }
      const resp = await fetch(apiUrl(`/api/admin/user-otps/${editing.id}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      if (!resp.ok) throw new Error('failed')
      message.success('تم حفظ التعديلات')
      setEditing(null)
      await load()
    } catch (e) {
      console.error(e)
      message.error('تعذر حفظ التعديلات')
    }
  }

  const columns = [
    { title: 'المعرف', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'الهاتف', dataIndex: 'phoneNumber', key: 'phoneNumber' },
    { title: 'الكود', dataIndex: 'code', key: 'code' },
    { title: 'الانتهاء', dataIndex: 'expiry', key: 'expiry' },
    { title: 'المحاولات', dataIndex: 'attempts', key: 'attempts' },
    { title: 'الحالة', dataIndex: 'status', key: 'status', render: (v) => <Tag>{v}</Tag> },
    { title: 'أنشئ في', dataIndex: 'createdAt', key: 'createdAt', width: 180 },
    { title: 'عدل في', dataIndex: 'updatedAt', key: 'updatedAt', width: 180 },
    {
      title: 'إجراءات', key: 'actions', fixed: 'right', width: 120,
      render: (_, record) => (
        <Space>
          <Button onClick={() => openEdit(record)}>تعديل</Button>
        </Space>
      ),
    },
  ]

  return (
    <div style={{ maxWidth: 1200, margin: '24px auto', padding: '0 12px' }}>
      <Card title="إدارة أكواد OTP" extra={<Button onClick={load}>تحديث</Button>}>
        <Table
          rowKey="id"
          dataSource={data}
          columns={columns}
          loading={loading}
          pagination={{ pageSize: 20 }}
          scroll={{ x: 1000 }}
        />
      </Card>

      <Modal
        open={!!editing}
        title={`تعديل السجل #${editing?.id}`}
        onCancel={() => setEditing(null)}
        onOk={saveEdit}
        okText="حفظ"
        cancelText="إلغاء"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="phoneNumber" label="الهاتف" rules={[{ required: true, message: 'الهاتف مطلوب' }]}> 
            <Input placeholder="05XXXXXXXX" />
          </Form.Item>
          <Form.Item name="code" label="الكود">
            <Input />
          </Form.Item>
          <Form.Item name="expiry" label="وقت الانتهاء">
            <DatePicker showTime style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="attempts" label="عدد المحاولات">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="status" label="الحالة">
            <Input placeholder="issued/verified/expired..." />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
